module.exports = __webpack_public_path__ + "img/customer.92ae718c.svg";